var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card h-100 card-inner" }, [
      _c("a", { staticClass: "position-relative", attrs: { href: "#" } }, [
        _c("div", [
          _c("img", {
            staticClass: "card-img",
            attrs: { src: "/images/news/news1.png", alt: "" },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c("h3", { staticClass: "card-title h6" }, [
            _c("span", { staticClass: "link stretched-link" }, [
              _vm._v(
                "\n        Zgłoś swój przejazd - Internetowy formularz\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "card-text" }, [
            _vm._v(
              "\n        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod...\n      "
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-footer mt-3" }, [
        _c("small", [_vm._v("\n      12.10.2020 16:35\n    ")]),
        _vm._v(" "),
        _c("p", [
          _c("small", [
            _c("a", { staticClass: "link", attrs: { href: "#" } }, [
              _vm._v("#Hash"),
            ]),
            _vm._v(" "),
            _c("a", { staticClass: "link", attrs: { href: "#" } }, [
              _vm._v("#amet"),
            ]),
            _vm._v(" "),
            _c("a", { staticClass: "link", attrs: { href: "#" } }, [
              _vm._v("#eiusmod"),
            ]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }